import { handleAuthorization, handleOkResponseJson, apiFetch } from "./handlers"
import { obterToken } from "./loginService"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';
import { normalizeTextUppercase, normalizeItemsUppercase } from '../utils'

export default {
    obterSolicitacoesAsync,
    obterMetricasAsync,
    editarSolicitacaoAsync,
    enviarSolicitacaoAsync,
    inativarSolicitacaoAsync,
    aprovarSolicitacaoAsync,
    obterSolicicoesBaixaAsync,
    baixarSolicitacaoAsync,
    getPdf,
    downloadLista,
    downloadListaBaixa
}

export const obterSolicitacoesAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Solicitacao/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterListaProdutosCotacaoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Solicitacao/obterListaProdutosCotacao`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterSolicicoesBaixaAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Solicitacao/obterListaBaixada`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarSolicitacaoAsync = async (idrequisicao, prioridade, idUnidadeAdm, idLocalEntrega, observacao, produtos) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ idrequisicao, prioridade, idUnidadeAdm, idLocalEntrega, observacao: normalizeTextUppercase(observacao), produtos: normalizeItemsUppercase(produtos, ["observacao"]) })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Solicitacao`, requestOptions);
}

export const cancelarItemSolicitacaoAsync = async (id) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Solicitacao/cancelarItemSolicitacao`, requestOptions);
}
export const editarSolicitacaoAsync = async (id,idUnidadeAdm, idLocalEntrega, observacao, prioridade, produtos) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, idUnidadeAdm, idLocalEntrega, observacao: normalizeTextUppercase(observacao), prioridade, produtos: normalizeItemsUppercase(produtos, ["observacao"]) })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Solicitacao/atualizar`, requestOptions);
}

export const inativarSolicitacaoAsync = async (id, justificativa) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, justificativa })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Solicitacao/inativar`, requestOptions);
}

export const aprovarSolicitacaoAsync = async (id, observacaoAutorizador, produtos) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, observacaoAutorizador, produtos: normalizeItemsUppercase(produtos, ["observacao"]) })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Solicitacao/aprovar`, requestOptions);
}

export const desautorizarSolicitacaoAsync = async (id, observacaoAutorizador, produtos) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, observacaoAutorizador, produtos: normalizeItemsUppercase(produtos, ["observacao"]) })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Solicitacao/desautorizar`, requestOptions);
}

export const baixarSolicitacaoAsync = async (id, observacaoAutorizador, unidadeAdm, idUnidadeAdm, status, local, idLocal, prioridade, data, produtos) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, observacaoAutorizador, unidadeAdm, idUnidadeAdm, status, local, idLocal, prioridade, data, produtos: normalizeItemsUppercase(produtos, ["observacao"]) })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Solicitacao/baixar`, requestOptions);
}

export const declinarSolicitacaoAsync = async (id, observacaoAutorizador) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, observacaoAutorizador })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/Solicitacao/declinar`, requestOptions);
}

export function downloadLista() {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Solicitacao/downloadSolicicoes`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            return { status: false };
        })
            .then((response) => {
                if (response.status === false)
                    return response;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'solicicoes' + '.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}

export function downloadListaBaixa() {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Solicitacao/downloadSolicicoesBaixadas`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            return { status: false };
        })
            .then((response) => {
                if (response.status === false)
                    return response;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'solicicoes' + '.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}

export function getPdf(id, janelaPdf = null) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Solicitacao/downloadPdf/` + id,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            fecharJanelaPdf(janelaPdf);
            return { status: false };
        })
            .then((response) => {
                if (response.status === false) {
                    fecharJanelaPdf(janelaPdf);
                    return response;
                }
                abrirBlobPdf(response.data, janelaPdf);
            });
    } catch (e) {
        fecharJanelaPdf(janelaPdf);
        throw e;
    }
}

export function getPdfBaixa(id, janelaPdf = null) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Solicitacao/downloadPdf/` + id,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            fecharJanelaPdf(janelaPdf);
            return { status: false };
        })
            .then((response) => {
                if (response.status === false) {
                    fecharJanelaPdf(janelaPdf);
                    return response;
                }
                abrirBlobPdf(response.data, janelaPdf);
            });
    } catch (e) {
        fecharJanelaPdf(janelaPdf);
        throw e;
    }
}

export const obterMetricasAsync = async () => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
  };

  return fetch(`${process.env.VUE_APP_API_URL}/Solicitacao/metricas`, requestOptions)
    .then(handleAuthorization)
    .then(handleOkResponseJson)
    .then(result => result.data);
}
